import { Route } from "react-router-dom";
import { ROUTES, toStandalonePath } from "./manifest";

/** See farmers_pulse/routes.jsx for the pattern. */
export default function WeatherPulseRoutes({ standalone = false } = {}) {
  return ROUTES.map((r) => (
    <Route
      key={r.name}
      path={standalone ? toStandalonePath(r.path, r.standalonePath) : r.path}
      element={r.element}
    />
  ));
}
